// extracted by css-extract-rspack-plugin
export default {"dropzone":"dropzone-Nu4vUN","active":"active-DGwUNM","disabled":"disabled-rQB7pj","overlay":"overlay-arkslt","spinner":"spinner-GBovSi","spin":"spin-WIJ3sg","hint":"hint-IR9h3h"};